var modules_3e23959b = {"container":"_zbux9d"};
import "../../../assets/B58uFvgJ.css";

export { modules_3e23959b as default };
//# sourceMappingURL=FooterLinks.module.less.js.map
